import parse, { type HTMLReactParserOptions } from 'html-react-parser';

export { parse, type HTMLReactParserOptions };
